import { supabase } from '../config/supabase';

/**
 * Запрашивает приветственное письмо (Edge Function + тот же SMTP, что у Auth).
 * Без ошибки для UI: сбой почты не блокирует вход.
 */
export async function requestWelcomeEmailIfNeeded(): Promise<void> {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) return;

    const { error } = await supabase.functions.invoke('send-welcome-email', {
      method: 'POST',
      headers: { Authorization: `Bearer ${session.access_token}` },
    });

    if (error) {
      console.warn('[welcome-email]', error.message);
    }
  } catch (e) {
    console.warn('[welcome-email]', e instanceof Error ? e.message : String(e));
  }
}
